import { render, staticRenderFns } from "./mdBackQueryRc.vue?vue&type=template&id=4768115f&scoped=true"
import script from "./mdBackQueryRc.vue?vue&type=script&lang=js"
export * from "./mdBackQueryRc.vue?vue&type=script&lang=js"
import style0 from "./mdBackQueryRc.vue?vue&type=style&index=0&id=4768115f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4768115f",
  null
  
)

export default component.exports